export const skeletonCustomFields = [{
  data: { options: ['Option 1', 'Option 2'] }, id: 'skeletonCustomField1', required: false,
  subtitle: '<div class="trix-content"></div>', title: 'Multiple Choice', type: 'CustomFieldMultipleChoice',
}, {
  data: { options: ['Option 1', 'Option 2'] }, id: 'skeletonCustomField2', required: false,
  subtitle: '<div class="trix-content"></div>', title: 'Multiple Choice 2', type: 'CustomFieldMultipleChoice',
}]
